<template>
  <div class="passport-container">
    <div class="logo-container">
      <div class='logo'><a href=""><img src="../../assets/images/logo.png" height="32px" width="125px"/></a></div>
    </div>
    <div class="passport dialog-form">
      <h1>重置密码</h1>
      <div class="error-tip-container">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
      </div>
      <h3 class="sm-tip" v-if="sendEmailSuccess">密码重置成功</h3>
      <p class="sm-tip" v-if="sendEmailSuccess">
        <a class="normal-content" href="/login">点击此处，使用新密码去登录</a>
        <a class="dialog-content" @click="showLoginDialog()">点击此处，使用新密码去登录</a>
      </p>
      <div v-if="!sendEmailSuccess">
        <div class="text-center" style="height: 280px;padding-top: 90px;" v-show="loading">
          <Loading type="1"></Loading>
        </div>
        <el-form ref="form" :model="form" :rules="rules" v-if="!loading">
          <el-form-item label="" prop="verify_code">
            <YueDanIpt model="verify_code" type="verify_code" :object="form" placeholder="请输入短信验证码">
              <span v-if="seconds > 0" style="color:#888;font-size:10px;top: -6px;" class="get-password">{{seconds}}s后重新获取</span>
              <a v-if="seconds == 0" style="top: 5px;" class="get-password" @click="getCode()">获取验证码</a>
            </YueDanIpt>
          </el-form-item>
          <el-form-item label="" prop="new_password">
            <YueDanIpt model="new_password" type="password" :object="form" placeholder="请输入新密码"></YueDanIpt>
          </el-form-item>
          <div class="btn-container">
            <el-button type="primary block" @click="submit()" :loading="loading">提&nbsp;交</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../services/api.js'
import YueDanIpt from '../../components/YueDanIpt'
import Loading from '../../components/Loading'
let $ = require('jQuery')

export default {
  name: 'ResetPwdByEmail',
  props: ['mobile'],
  components: {
    YueDanIpt: YueDanIpt,
    Loading: Loading
  },
  created() {
    this.form.mobile = this.mobile
    this.calRsendTime()
  },
  data () {
    return {
      form: {
        verify_code: '',
        new_password: '',
        mobile: ''
      },
      timer: null,
      seconds: 60,
      loading: false,
      errors: null,
      isEmptyErrors: true,
      sendEmailSuccess: null,
      rules: {
        new_password: [
          { required: true, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,30}$/, message: '密码长度至少为8 位，且必须同时包含大写字母、小写字母和数字', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submit: function () {
      this.$refs['form'].validate((valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors
        if (valid) {
          api.post(this, {
            path: 'passport.php',
            data: this.form,
            loading: 'loading',
            api: 'forget_password_submit'
          }).then((res) => {
            if (res.body.status === 'ok') {
              if (res.body.result === 'wrong_verify_code') {
                this.errors = {
                  verify_code: [
                    {message: '验证码错误'}
                  ]
                }
              } else {
                this.sendEmailSuccess = true
              }
              // this.$emit('success')
            }
          }, err => {

          })
        } else {
          return false;
        }
      })
    },
    showLoginDialog () {
      this.$store.commit('showGlobalDialog', 'loginVisible')
    },
    getCode () {
      api.post(this, {
          path: 'passport.php',
          data: this.form,
          loading: 'loading',
          api: 'forget_password_send_sms'
        }).then((res) => {
          if (res.body.status === 'ok') {
            if (res.body.result === 'no_such_user') {
              this.isEmptyErrors = false
              this.errors = {
                verify_code: [
                  {message: '此手机尚未注册，请前去注册'}
                ]
              }
            } else {
              this.seconds = 60
              this.calRsendTime()
            }
          }
        }, err => {

        })
    },
    calRsendTime () {
      this.timer = setInterval(() => {
        this.seconds --

        if (this.seconds == 0) {
          clearInterval(this.timer)
        }
      }, 1000)
    }
  },
  beforeDestroy: function() {
      clearInterval(this.timer)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/passport/ResetPwdByMobile.vue